'use strict';

var StrategyReadonlyCustomDirective = function StrategyReadonlyCustomDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmStrategyReadonly',
    template: require('../templates/strategy-readonly-custom.html')
  };
};
StrategyReadonlyCustomDirective.$inject = [];
module.exports = StrategyReadonlyCustomDirective;